import type { JSX, SVGProps } from 'react';
import { useNavigate } from 'react-router';

import type { CategoriesV2 } from '~/api/v2/mall/common-data';
import { CampaignTypeV2 } from '~/api/v2/schemas/campaign-type';
import type { RewardTypeV2 } from '~/api/v2/schemas/reward-type';
import { DATA_AREAS } from '~/constants/data-areas';
import { filterCategoriesByRewardType } from '~/utils';

export type CategoryStyles = {
  base: string;
  item: string;
  link: string;
  icon: string;
  name: string;
};
type SvgComponent = (props: SVGProps<SVGSVGElement>) => JSX.Element;
export type CategoryIcons = Record<number, SvgComponent>;

type Props = {
  categories: CategoriesV2;
  styles: CategoryStyles;
  categoryIcons: CategoryIcons;
  rewardType?: RewardTypeV2;
};

export const Category = (props: Props) => {
  const { styles, categories, categoryIcons, rewardType } = props;
  const filteredCategories =
    rewardType !== undefined ? filterCategoriesByRewardType(categories, rewardType) : categories;
  const navigate = useNavigate();

  return (
    <ul className={styles.base} data-area={DATA_AREAS.CATEGORY}>
      {filteredCategories &&
        Object.keys(filteredCategories).map((id) => {
          const Icon = categoryIcons[Number(id)];
          return (
            <li className={styles.item} key={id}>
              <button
                className={styles.link}
                onClick={() => {
                  const searchParams = `?category_id=${id}${
                    rewardType !== undefined ? `&campaign_type=${CampaignTypeV2.SHOP}&reward_type=${rewardType}` : ''
                  }`;
                  navigate(`${import.meta.env.VITE_CAMPAIGN_SEARCH_ROUTE}${searchParams}`);
                }}>
                {Icon && <Icon className={styles.icon} />}
                <p className={styles.name}>{categories[id].name}</p>
              </button>
            </li>
          );
        })}
    </ul>
  );
};
